import * as React from "react";
import { alpha, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import heroImg from "../assets/heroImg10.png";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
AOS.init();

export const Hero = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: "100%",
        background:
          theme.palette.mode === "light"
            ? "#f6f4fa"
            : `linear-gradient(#02294F, ${alpha("#090E10", 0.0)})`,
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
      })}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 18, sm: 22 },
          pb: { xs: 8, sm: 4 },
        }}
      >
        <Stack spacing={1} useFlexGap sx={{ width: { xs: "100%", sm: "70%" } }}>
          <Typography
            component="div"
            variant="body1"
            sx={{
              color:
                theme.palette.mode === "light"
                  ? theme.palette.secondary.main
                  : "#9043c6",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            CODE. CREATE. INNOVATE
          </Typography>
          <Typography
            variant="h1"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              alignSelf: "center",
              textAlign: "center",
              fontSize: "clamp(2.5rem, 9vw, 3rem)",
              fontWeight: "bold",
              mt: 3,
            }}
          >
            Transforming Ideas Into&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={{
                fontSize: "clamp(2rem, 9vw, 3rem)",
                fontWeight: "bold",
                mb: 3,
                color: (theme) =>
                  theme.palette.mode === "light"
                    ? "primary.main"
                    : "primary.light",
              }}
            >
              Reality.
            </Typography>
          </Typography>
          <Typography
            textAlign="center"
            color="text.secondary"
            sx={{ alignSelf: "center", width: { sm: "100%", md: "80%" } }}
          >
            Snyprs revolutionizes tech landscapes, empowering businesses with
            innovative approaches and cutting-edge technologies for enhanced
            efficiency and success.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignSelf="center"
            spacing={2}
            useFlexGap
            sx={{ pt: 2, pb: 2, width: { xs: "100%", sm: "auto" } }}
          >
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={() => navigate("/get-a-quote")}
            >
              Get a Quote
            </Button>

            <Button
              variant="outlined"
              size="large"
              color="primary"
              onClick={() => window.open("/book-a-call", "_blank")}
            >
              Book a Call
            </Button>
          </Stack>
          <Typography
            variant="caption"
            textAlign="center"
            sx={{ opacity: 0.8 }}
          >
            By clicking &quot;Above button&quot; you agree to our&nbsp;
            <Link href="/" color="primary">
              Terms & Conditions
            </Link>
            .
          </Typography>
        </Stack>
        <Box
          data-aos="fade-up"
          data-aos-duration="2000"
          id="image"
          sx={(theme) => ({
            mt: { xs: 8, sm: 10 },
            alignSelf: "center",
            height: { xs: 200, sm: 400, md: 700 },
            width: "100%",
            backgroundImage:
              theme.palette.mode === "light"
                ? `url(${heroImg})`
                : `url(${heroImg})`,
            backgroundSize: "cover",
            borderRadius: "10px",
            outline: "1px solid",

            outlineColor:
              theme.palette.mode === "light"
                ? alpha("#BFCCD9", 0.5)
                : alpha("#9CCCFC", 0.1),
            boxShadow:
              theme.palette.mode === "light"
                ? `0 0 12px 8px ${alpha("#9CCCFC", 0.2)}`
                : `0 0 24px 12px ${alpha("#033363", 0.2)}`,
          })}
        />
      </Container>
    </Box>
  );
};
